/**
 * 앱 설정 채널 — 건의함·업로드 설정·번역 (v1.18)
 *
 * 선택지는 여기가 단일 원천이다. DB에는 코드만 저장하고 라벨은 화면에서 붙인다
 * (§13.1 — 문구 수정에 마이그레이션이 필요 없게).
 */
/** 건의 분류 — 이용자가 보내는 목소리의 갈래 */
export const FEEDBACK_CATEGORIES = [
    { code: 'SUGGESTION', label: '이런 기능이 있으면 좋겠어요' },
    { code: 'INCONVENIENCE', label: '쓰다가 불편했어요' },
    { code: 'PRAISE', label: '칭찬하고 싶어요' },
    { code: 'OTHER', label: '기타' },
];
export function feedbackCategoryLabel(code) {
    return FEEDBACK_CATEGORIES.find((c) => c.code === code)?.label ?? code;
}
export const FEEDBACK_MAX_LENGTH = 2000;
/**
 * 번역 대상 언어 (§5.28 다문화가정 지원).
 * 국내 다문화 가정에서 많이 쓰는 언어 순.
 */
export const TRANSLATE_LANGUAGES = [
    { code: 'en', label: 'English (영어)' },
    { code: 'vi', label: 'Tiếng Việt (베트남어)' },
    { code: 'zh', label: '中文 (중국어)' },
    { code: 'ja', label: '日本語 (일본어)' },
    { code: 'th', label: 'ภาษาไทย (태국어)' },
    { code: 'tl', label: 'Filipino (필리핀어)' },
    { code: 'km', label: 'ខ្មែរ (크메르어)' },
    { code: 'mn', label: 'Монгол (몽골어)' },
    { code: 'ru', label: 'Русский (러시아어)' },
    { code: 'uz', label: "O'zbekcha (우즈베크어)" },
];
export function translateLanguageLabel(code) {
    return TRANSLATE_LANGUAGES.find((l) => l.code === code)?.label ?? code;
}
/** 번역 원문 길이 상한 — 알림장·공지 본문이 대상이라 이 정도면 넉넉하다 */
export const TRANSLATE_MAX_LENGTH = 3000;
/** 번역 일일 사용 한도(1인) — 챗봇(10회)보다 여유 있게, 남용은 막는 수준 */
export const TRANSLATE_DAILY_LIMIT = 50;
/** 사진 업로드 화질 선택지 — 권장은 긴 변 기준으로 줄여 데이터 사용량을 아낀다 */
export const UPLOAD_QUALITY_OPTIONS = [
    { code: 'recommended', label: '권장 화질 (1920px)' },
    { code: 'original', label: '원본 화질' },
];
export const UPLOAD_RECOMMENDED_EDGE = 1920;
//# sourceMappingURL=app-settings.js.map